import CityInput from '@/core/components/inputs/CityInput/CityInput';

export default CityInput;
